import { useQuery } from "@tanstack/react-query"

import { NAFTA_ORGANIZATION_INFO_QUERY_KEY } from "@/constants/query"
import { getMenuLinks } from "@/http/menuLinks"


export const useMenuLinks = () => {
  return useQuery({
    queryFn: () => getMenuLinks(),
    queryKey: [NAFTA_ORGANIZATION_INFO_QUERY_KEY],
    retry: false
  })
}
